export class RecaptchaModel {
  public Name : string;
  public SiteKey : string;
  public SecretKey : string;
  public UpdatedBy: string;
  public IsDefault: boolean = false;
  public IsDeleted: boolean = false;

  public Id: number;
}
